
import {ENVIRONMENT_LEVEL} from "../constants/ConfigFromBuildEnvironment";

class LogLine {
    constructor(level, message, ...optionalParams) {
        this.level = level;
        this.message = message;
        this.optionalParams = optionalParams;
    }
}

class Logger {

    static LINES_TO_RETAIN = 100;

    constructor() {
        this.envionmentLevel = ENVIRONMENT_LEVEL === "PROD" ? 2 : ENVIRONMENT_LEVEL === "QA" ? 1 : 0;
        this.mostRecentLinesWritten = [];
    }

    debug(message, ...optionalParams) {
        if (this.envionmentLevel < 2) {
            console.log(message, ...optionalParams);
            this._updateRecentLines("DEBUG", message, optionalParams);
        }
    }

    info(message, ...optionalParams) {
        if (this.envionmentLevel < 2) {
            console.info(message, ...optionalParams);
            this._updateRecentLines("INFO", message, optionalParams);
        }
    }

    warn(message, ...optionalParams) {
        console.warn(message, ...optionalParams);
        this._updateRecentLines("WARN", message, optionalParams);
    }

    error(message, ...optionalParams) {
        console.error(message, ...optionalParams);
        this._updateRecentLines("ERROR", message, optionalParams);
    }

    _updateRecentLines(level, message, ...optionalParams) {
        this.mostRecentLinesWritten.push(new LogLine(level, message, optionalParams));
        if (this.mostRecentLinesWritten.length > Logger.LINES_TO_RETAIN) {
            this.mostRecentLinesWritten.pop();
        }
    }

}

export default new Logger();